var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.3466 14C13.4851 14 14.4081 13.1046 14.4081 12C14.4081 10.8954 13.4851 10 12.3466 10C11.2081 10 10.2852 10.8954 10.2852 12C10.2852 13.1046 11.2081 14 12.3466 14Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M23.4455 11.357C23.2208 11.098 17.8878 5 12.3477 5C6.80751 5 1.47454 11.098 1.24984 11.357L0.695312 12L1.24984 12.643C1.47454 12.902 6.80751 19 12.3477 19C17.8878 19 23.2208 12.902 23.4455 12.643L24 12L23.4455 11.357ZM12.3477 16C10.0739 16 8.22476 14.206 8.22476 12C8.22476 9.794 10.0739 8 12.3477 8C14.6214 8 16.4706 9.794 16.4706 12C16.4706 14.206 14.6214 16 12.3477 16Z","fill":"currentColor","key":1})]);
}

Eye.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Eye;

Eye.default = Eye;
